module.exports = __webpack_public_path__ + "static/Gilroy-ExtraBold-b5cebf34d07db8c30797907e847028fe.woff";